import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import AnimatedDots from '../../styled-components/LoadingDots/LoadingDots';
import { AnimationWrapper, AnimationBackground, } from './LoadingAnimationStyles';
export default function LoadingAnimation({ isLoading = true, height = 40, }) {
    return (_jsx(AnimationWrapper, Object.assign({ show: isLoading }, { children: _jsx(AnimationBackground, Object.assign({ height: height }, { children: _jsx(AnimatedDots, { height: height }) })) })));
}
